import React from "react";
import '../styles/Projects.css';
import Card from "../../components/scripts/Card";

class Projects extends React.Component{
    projectList = (projectList) =>{
        const project = projectList.map((p, index) => {
            return <Card key={index} title={p.name} desc={p.description} github={p.github} web={p.demo} />
        });
        return project;
    }
    render(){
        const {projectList, links} = this.props;
        return(
            <div className="project_div">
                <div className="sub-title-div">
                    <p className="tc"> Recent Projects </p>
                </div>
                <div className="more-div">
                    <a href={links.github} target="_blank">and more...</a>
                </div>
                <div className="projects">
                    {this.projectList(projectList)} 
                </div>
                
            </div>
        );
    }
}

export default Projects;